export const OverrideAdminFeatureFlagName = 'OverrideAdminFeatureFlagByCustomerId';
export const UseDefaultAdminFeatureFlagName = 'UseDefaultAdminFeatureFlagByCustomerId';
